import { Service } from '../config'

class MarketStockService extends Service {
  async getStock(params: any) {
    const httpResponse = await this.httpClient.get(
      `precificacao/estoque?estadoId=${params?.uf ?? ''}&cidadeId=${
        params?.city ?? ''
      }&modeloId=${params?.modelId ?? ''}&anoModelo=${params?.yearModel ?? ''}`
    )
    return httpResponse
  }

  async kbbPrice(code: string, year: string, inspectionId: string) {
    const httpResponse = await this.httpClient.get(
      `kbb/preco?Ano=${year}&CodigoFipe=${code}&VistoriaId=${inspectionId}`
    )
    return httpResponse
  }

  async fipeModel(params?: {
    codigoFipe: string
    ano: string
    quantidadeMeses: number
  }) {
    const httpResponse = await this.httpClient.get('fipe/modelo', { params })
    return httpResponse
  }

  async internal(params?: any) {
    const httpResponse = await this.httpClient.get(
      `precificacao/historicointerno?ModeloId=${
        params?.modeloId ?? ''
      }&AnoModelo=${params?.anoModelo ?? ''}&DiretoriaId=${
        params?.diretoriaId ?? ''
      }&FaixaKmInicial=${params?.faixaKmInicial ?? ''}&FaixaKmFinal=${
        params?.faixaKmFinal ?? ''
      }&TipoAvaliacao=${params?.tipoAvaliacao ?? ''}`
    )
    return httpResponse
  }

  async getReferenceHistory(params: any) {
    const httpResponse = await this.httpClient.get(
      `precificacao/historicoreferencia`,
      {
        params,
        paramsSerializer: { indexes: null }
      }
    )
    return httpResponse
  }
}

export const marketStockService = new MarketStockService()
